import React, { useEffect } from 'react';
import { FieldArray, useFormikContext } from 'formik';
import _get from 'lodash/get';

import Field from 'legacy/common/components/wysiwyg-form/Field';
import FadeIn from 'legacy/common/components/transition/FadeIn';
import { FormValueDto } from './forms/TicketForm/helpers/computeInitialValues';

interface TicketQuestionsProps {
  name: string;
}

const TicketQuestions: React.FC<TicketQuestionsProps> = ({ name }) => {
  const { values, setFieldValue } = useFormikContext<FormValueDto>();

  // Use lodash get to correctly access nested properties
  const questionsArray = _get(values, name) || [];

  useEffect(() => {
    if (questionsArray.length === 0) {
      setFieldValue(name, [
        {
          question: ''
        }
      ]);
    }
  }, [name, questionsArray, setFieldValue]);

  return (
    <FieldArray
      name={name}
      render={(arrayHelpers) => (
        <div className="mt-4 p-4 border-1 border-gray-200 rounded-md">
          {questionsArray.map((_, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={index}>
              <FadeIn>
                <Field
                  id={`${name}[${index}].question`}
                  name={`${name}[${index}].question`}
                  label="Screening question (Optional)"
                />
                <div className="-mt-4 flex items-center">
                  <div className="w-full border-b-1 border-gray-200" />
                  <button
                    type="button"
                    className="pl-4 text-red-700 text-sm"
                    onClick={() => arrayHelpers.remove(index)}
                  >
                    Remove
                  </button>
                </div>
              </FadeIn>
            </div>
          ))}

          {questionsArray.length > 0 && (
            <button
              type="button"
              className="mt-2 text-primary-500 font-semibold text-sm"
              onClick={() =>
                arrayHelpers.push({
                  question: ''
                })
              }
            >
              + Add another question
            </button>
          )}
        </div>
      )}
    />
  );
};

export default TicketQuestions;
